export default __webpack_public_path__ + "static/social-estados-diff_en-025eb6d5d990605dd5e333877ad07619.png";